<script setup>
import SettingsMenu from "@/components/settings/SettingsMenu.vue";
</script>

<template>
  <v-container fluid class="pa-0 ma-0">
    <v-row class="pa-0 ma-0 h-100">
      <v-col cols="3" class="ps-3 pe-3 h-100 border-e">
        <settings-menu></settings-menu>
      </v-col>
      <v-col cols="9">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>